import { render, staticRenderFns } from "./PvHeader.vue?vue&type=template&id=1c03ac00&"
import script from "./PvHeader.vue?vue&type=script&lang=js&"
export * from "./PvHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports